<template>
  <el-dialog
    :visible.sync="value.visible"
    title="标签管理"
    append-to-body
    :destroy-on-close="true"
    width="700px"
    @open="onDlgOpen"
    @closed="onDlgClosed"
  >
    <div v-loading="$store.state.app.loadingList.includes('listTag-DlgTagManagement')" />
    <div>
      <div class="my-2_5 row-between">
        <div>{{ tagList.length }} 条标签</div>
        <el-button size="small" type="primary" plain @click="onNewTag">
          <span class="iconfont icon-plus" /> 标签
        </el-button>
      </div>

      <div v-for="(item, index) in tagList" :key="index" class="my-2_5">

        <!-- <div class="my-1"><el-tag :color="item.styleCode" effect="dark" type="info" :style="`border-color: ${item.styleCode};`" class="mr-5">{{
          item.tag
        }}</el-tag></div> -->
        <div class="row-wrap has-bg-whiteless py-2 px-3 border-radius-m mt-3">
          <div class="mr-4 my-1">
            <span class="mr-2 has-text-light">标签名称</span>
            <el-input
              v-model="item.tag"
              type="text"
              maxlength="30"
              minlength="1"
              style="width: 150px;"
              @change="onNameChange(item)"
            />
          </div>
          <!-- <div class="mr-5 my-1">
            <span class="mr-1 has-text-light">设置颜色</span>
            <input v-model="item.styleCode" type="color" style="width: 20px; height: 20px;" @change="item.dirty = true">
          </div> -->
          <div class="mr-4 has-text-light my-1">被使用 {{ item.obj_count }}</div>
          <div class="grow" />
          <div class="my-1">
            <el-button v-show="!item.dirty" :loading="$store.state.app.loadingList.includes('delTag_' + index)" class="" type="danger" size="small" :disabled="$store.state.app.loadingList.includes('delTag_' + index)" plain @click="onDel(item, index)">
              删除
            </el-button>
            <el-button v-show="item.dirty" :loading="$store.state.app.loadingList.includes('saveTag_' + index)" class="" type="success" size="small" :disabled="$store.state.app.loadingList.includes('saveTag_' + index)" plain @click="onSave(item, index)">
              保存
            </el-button>
          </div>
        </div>
      </div>

    </div>
  </el-dialog>
</template>

<script>
import { createTag, listTag, updateTag, delTag } from '@/api/util'
import { nanoid } from 'nanoid'

export default {
  name: 'DlgTagManagement',
  components: {
  },
  props: {
    orgId: {
      type: String,
      default: ''
    },
    formId: {
      type: String,
      default: ''
    },
    tagType: {
      type: Number,
      default: 0
    },
    // 原则上vue的props应该是只读的，但vue对对象中的内容没有监测，这里不管了，直接把modelValue当作可写的
    value: {
      type: Object,
      default: () => ({
        visible: false
      })
    }
  },
  emits: ['closed'],
  data() {
    return {
      tagList: [],
      isChanged: false

    }
  },
  computed: {
    // val: {
    //   get() {
    //     return this.params;
    //   },
    //   set(v) {
    //     this.$emit("update:params", v);
    //     console.log(v);
    //   },
    // },
  },
  watch: {
    // modelValue: {
    //   // eslint-disable-next-line no-unused-vars
    //   handler(newValue, oldValue) {
    //     this.value =  newValue;
    //   },
    //   deep: true,
    // },
  },
  created() {
  },
  async mounted() {
    console.log(this.value)
  },

  methods: {

    async listTag() {
      this.tagList = []
      this.tagList = await listTag({
        query: `?org_id=${this.orgId}&form_id=${this.formId}&tag_type=${this.tagType}`
      }, 'listTag-DlgTagManagement')
    },

    async onDlgOpen() {
      await this.listTag()
      this.isChanged = false
    },

    async onDlgClosed() {
      // this.tagList = [];
      this.$emit('closed', this.isChanged)
    },

    async onDel(item, index) {
      const that = this
      that.$confirm('确认要删除？', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        // item.loading = true
        console.log('onDel')
        that.$forceUpdate() // 有时不刷新，强制刷新
        const res = await delTag({
          id: item.id,
          org_id: that.orgId,
          form_id: that.formId,
          tag_type: that.tagType
        }, 'delTag_' + index)
        console.log(res)
        // eslint-disable-next-line require-atomic-updates
        // item.loading = false
        that.$forceUpdate() // 有时不刷新，强制刷新
        that.tagList.splice(index, 1)
        // eslint-disable-next-line require-atomic-updates
        that.isChanged = true

        that.$message({
          message: '操作成功',
          type: 'success',
          center: true
        })
      }).catch(() => {})
    },

    async saveTag(param, index) {
      let res
      if (!param.id) {
        res = await createTag(param, 'saveTag_' + index)
      } else {
        res = await updateTag(param, 'saveTag_' + index)
      }

      return res
    },

    async onSave(item, index) {
      const that = this

      if (item.tag.length < 1) {
        that.$message({
          message: '名称必须填',
          type: 'error',
          center: true
        })
        return
      }
      // item.loading = true
      this.$forceUpdate() // 有时不刷新，强制刷新
      const res = await that.saveTag({
        id: item.id,
        org_id: that.orgId,
        form_id: that.formId,
        tag_type: that.tagType,
        tag: item.tag
      }, index)

      console.log(res)
      // eslint-disable-next-line require-atomic-updates
      // item.loading = false
      // eslint-disable-next-line require-atomic-updates
      item.dirty = false
      // eslint-disable-next-line require-atomic-updates
      item.id = res
      this.$forceUpdate() // 有时不刷新，强制刷新

      // eslint-disable-next-line require-atomic-updates
      that.isChanged = true

      that.$message({
        message: '操作成功',
        type: 'success',
        center: true
      })
    },

    onNewTag() {
      const uid = nanoid()
      this.tagList.unshift({
        tag: `标签${uid}`,
        // styleCode: '#909399',
        obj_count: 0,
        dirty: true
      })
    },

    onNameChange(item) {
      console.log('onNameChange', item)
      item.dirty = true
      this.$forceUpdate() // 有时不刷新，强制刷新
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
